module.exports = __webpack_public_path__ + "static/img_2546-8eeb200e4a58d7902e980c77d7a0d26a.webp";